module.exports = __webpack_public_path__ + "img/DE02136.3cb90179.png";